import Transition from '@ember/routing/-private/transition';
import { inject as service } from '@ember/service';
import FeaturesService from 'ember-feature-flags/services/features';
import Route from 'cio/routes/base';

export default class SubscriptionCenterSetPreferencesRoute extends Route {
  @service features!: FeaturesService;

  crumb() {
    return [
      {
        name: 'Subscriptions',
        path: 'workspace-settings.subscription_center.topics',
      },
      {
        name: 'Set preferences',
        path: 'workspace-settings.subscription_center.topics.set_preferences',
      },
    ];
  }

  redirect(_model: null, transition: Transition) {
    if (transition.to?.name === 'workspace-settings.subscription_center.topics.set_preferences.index') {
      this.router.transitionTo('workspace-settings.subscription_center.topics.set_preferences.type');
    }
  }
}
